import React, { useState, useEffect } from 'react';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
var ContestSummary = function ContestSummary(_ref) {
  var contest = _ref.contest;
  return /*#__PURE__*/_jsx(_Fragment, {});
};
export default ContestSummary;